export type TestimonialType = {
  tempId: number;
  testimonial: string;
  by: string;
  stars: number;
  date: string;
};

export const TESTIMONIAL_DATA: TestimonialType[] = [
  {
    tempId: 0,
    testimonial:
      'Der Dönerteller war sehr gut. Ich habe schon viele Döner gegessen und der gehört zu den Besten. Nette Jungens die dort bedienen( sehr freundlich) Gut,am Ambiente kann man noch arbeiten.',
    by: 'Ingo D.',
    stars: 5,
    date: '2024',
  },
  {
    tempId: 1,
    testimonial:
      'Super leckeres Essen, einfach genial lecker 👍👍👌👌 Sehr zu empfehlen und ein echter Geheimtipp!!! Gerne wieder 👌👌👍',
    by: 'Eyk S.',
    stars: 5,
    date: '2024',
  },
  {
    tempId: 2,
    testimonial:
      'Sympathischer Dönerladen! Wir kommen jedes Mal vorbei, wenn wir in der Gegend zu Besuch sind. Sehr empfehlenswert: Falafel Dürüm mit frischem, fluffigem Fladenbrot und toller Soßenauswahl. Der Laden ist gepflegt und sauber. Freundliches Personal, gute Parkplatzsituation.',
    by: 'Sandra',
    stars: 5,
    date: '2023',
  },
  {
    tempId: 3,
    testimonial:
      '3 sehr freundliche und zuvorkommende Brüder leiten einen äußerst seriösen Döner Kebap im Herzen des Sauerlandes 💓',
    by: 'Patric da S. C.',
    stars: 5,
    date: '2024',
  },
  {
    tempId: 4,
    testimonial:
      'waren heute Abend um etwa 21:45 Uhr dort und haben, um diese Zeit, sehr frisch gemachtes und heißes Essen bekommen und es war super lecker 😋👍👍👍👍',
    by: 'Manuela B.',
    stars: 5,
    date: '2024',
  },
  {
    tempId: 5,
    testimonial:
      'Der Name Schmeckt lecker paßt genau zu diesem Imbiss und die Bedienung ist auch sehr nett.',
    by: 'Harald K.',
    stars: 5,
    date: '2024',
  },
  {
    tempId: 6,
    testimonial: 'Sehr lecker, was der Name schon sagt 😋😊 Immer wieder gerne',
    by: 'Tatjana M.',
    stars: 4,
    date: '2024',
  },
  {
    tempId: 7,
    testimonial: 'Tolle Menschen, tolle Leute, tolles Essen. Perfekter Ort. 😝',
    by: 'Marie F.',
    stars: 5,
    date: '2024',
  },
  {
    tempId: 8,
    testimonial:
      'Es schmeckt wirklich lecker. Sehr nette Inhaber. Der Beste in der weiten Umgebung. Ich würde es empfehlen!',
    by: 'Wowka O.',
    stars: 5,
    date: '2024',
  },
  {
    tempId: 9,
    testimonial:
      'Mache auf meinen rennrad Touren dort regelmäßig halt zum essen sehr große Auswahl es gibt alles von pommes döner bis Pizza 🍕 freundliche Bedienung preiswert',
    by: 'Wolfgang W.',
    stars: 5,
    date: '2022',
  },
  {
    tempId: 10,
    testimonial:
      'Seit langem wieder einen Imbiss mit richtig leckerem Essen gefunden. Bisher war ich immer ein paar Straßen weiter beim Imbiss, allerdings schmeckt es hier wirklich lecker, saftig und alles sehr frisch. Auch die Mitarbeiter sind super freundlich. Ich werde hier in Zukunft öfter was kaufen.',
    by: 'DER HÄNNES',
    stars: 5,
    date: '2024',
  },
  {
    tempId: 11,
    testimonial: 'Döner geschmacklich ok , nichts besonderes. Freundlich.',
    by: 'Bachkippe',
    stars: 3,
    date: '2023',
  },
];
